import React, { CSSProperties, ReactNode, useEffect, useRef, useState } from "react";
import PopupVirtualList from "../../MainPage/Tools/VirtualList/PopUpVirtualList";
import clsx from "clsx";
import styles from "../signin.module.css";
import { EventDataInfo } from "../../MainPage/Tools/VirtualList/VirtualList";
import { IconButton } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

interface Props {
  label?: string;
  type?: string;
  formKey?: string;
  autocomplete?: string;
  defaultValue?: EventDataInfo;
  items?: Array<EventDataInfo>;
  endButtons?: ReactNode;
  style?: CSSProperties;
  inputStyle?: CSSProperties;
  onPickListButtonClick?: (data?: any) => Promise<void> | void;
  onKeyDown?: (ev: React.KeyboardEvent<HTMLDivElement>) => void;
  onEdit: (val: string) => void;
}
const supportCss = typeof CSS !== "undefined" && CSS.supports && CSS.supports("selector(:has(a))");

export default function SignInEditor({
  label = "",
  type,
  formKey,
  autocomplete,
  items = [],
  endButtons,
  defaultValue,
  inputStyle,
  style,
  onEdit,
  onKeyDown,
  onPickListButtonClick,
}: Props) {
  const [inputValue, setInputValue] = useState(defaultValue?.label || "");
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(defaultValue);
  const [filter, setFilter] = useState(false);
  const virtualList = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const labelRef = useRef<HTMLInputElement>(null);
  const anchorEl = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current) inputRef.current.value = defaultValue?.label || "";
    onEdit(defaultValue?.label || "");
    if (!supportCss) {
      setTimeout(() => {
        if (inputValue) labelRef.current?.classList.add(clsx(styles.formLegacyLabel));
      }, 100);
    }
  }, []);

  useEffect(() => {
    setFilter(false);
  }, [open]);

  //для старых версий браузеров
  const legacySupportInputOnFocus = () => {
    labelRef.current?.classList.add(clsx(styles.formLegacyLabel));
  };
  const legacySupportInputOnBlur = () => {
    if (inputValue === "") labelRef.current?.classList.remove(clsx(styles.formLegacyLabel));
  };

  const filteredItems = () => {
    let result = !items.length ? [{ label: "Нет данных", id: "0", disabled: true }] : items;
    if (!filter) return result;
    result = result.filter((el) => {
      if (!el.label) return false;
      return el.label.toLowerCase().includes(inputValue.toLowerCase());
    });

    return !result.length ? [{ label: "Ничего не найдено", id: "0", disabled: true }] : result;
  };

  return (
    <div
      onKeyDown={(ev) => ev.code === "ArrowDown" && ev.altKey && setOpen(!open)}
      ref={anchorEl}
      style={{ height: "100%", width: "100%", ...style }}
    >
      <div
        onClick={() => {
          inputRef.current?.focus();
        }}
        className={clsx(styles.inputContainer)}
      >
        <div ref={labelRef} className={clsx(styles.formLabel)}>
          {label}
        </div>
        <input
          style={inputStyle}
          key={formKey}
          placeholder=" "
          onFocus={!supportCss ? legacySupportInputOnFocus : undefined}
          onBlur={!supportCss ? legacySupportInputOnBlur : undefined}
          type={type || "text"}
          className={clsx(styles.formInput)}
          name={autocomplete}
          autoComplete={autocomplete}
          ref={inputRef}
          onChange={(ev) => {
            const val = ev.target.value;
            setFilter(true);
            onEdit(val);
            setInputValue(val);
            setValue({ label: val });
          }}
        />
        {endButtons}
        {onPickListButtonClick && (
          <IconButton
            onClick={(ev) => {
              onPickListButtonClick(ev);
              setOpen(!open);
            }}
          >
            <ArrowDropDownIcon />
          </IconButton>
        )}
      </div>
      <PopupVirtualList
        anchorEl={anchorEl}
        open={open}
        items={filteredItems()}
        itemSize={30}
        leftShift={-28}
        topShift={28}
        minWidthSift={-52}
        inputRef={inputRef}
        inputValue={inputValue}
        onKeyDown={onKeyDown}
        onClose={(ev) => {
          if (ev.target === inputRef.current) return;
          setOpen(!open);
        }}
        onSelect={(data) => {
          if (!inputRef.current) return;
          setValue(data);
          setInputValue(data.label);
          inputRef.current.value = data.label;
          onEdit(data.label);
          setOpen(!open);
        }}
        value={value}
        virtualList={virtualList}
      />
    </div>
  );
}
